// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LWHxl","type":"styles_type__DhV-4","choices":"styles_choices__YPS8e"};